export default "__VITE_ASSET__Bbvt$Tu2__"